<template>
    <v-container fluid>
        <template>
            <h1>Sugerencias IA</h1>
            <router-view></router-view>
        </template>
    </v-container>
</template>

<script>
export default {
    props: ['id'],
    data: () => ({
    }),
}
</script>